import { useNavigate } from "react-router-dom";
import {
  isJwtExpired,
  timeToExpire,
} from "../components/authentication/checkJWT";
import { postData, getData } from "./auxilarFunctions";
import config from "../config.json";

const apiCache1 = new Map();
const apiCache2 = new Map();
const apiCache3= new Map();
const apiCache4 = new Map();
const apiCache5 = new Map();
const apiCache6 = new Map();
const apiCache7 = new Map();

const apiCacheP1 = new Map();
const apiCacheP2= new Map();
const apiCacheP3 = new Map();
const apiCacheP4 = new Map();
const apiCacheP5 = new Map();
const apiCacheP6 = new Map();
const apiCacheP7 = new Map();

function generateCacheKey(filters) {
  return JSON.stringify(filters);
}

let initial_state = {
  loading1: true,
  loading2: true,
  loading3: true,
  loading4: true,
  loading5: true,
  loading6: true,
  loading7: true,
  loadingP1: true,
  loadingP2: true,
  loadingP3: true,
  loadingP4: true,
  loadingP5: true,
  loadingP6: true,
  loadingP7: true,
  isDataLoaded: false,
  prescriptions: {
    othertotal: 0,
    othermale: 0,
    otherfemale: 0,
    otheractive_patients: 0,
    otherconsultations: 0,
    othertypes: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    other_week_days: [0, 0, 0, 0, 0],
    other_type_gms: 0,
    other_type_private: 0,
  },
  generalABcomparison: {
    othertotal: 0,
    otherperc_12_month: 0,
    otherperc_resistance_ab: 0,
  },
  consultationscomparison: {
    otherall: 0,
    otherab: 0,
  },
  prescriptionscomparison: {
    otherall: 0,
    otherab: 0,
  },

patients:{
  other_gender_patients: [0, 0],
  other_gender_categories: [
    'Male', 
    'Female'
  ],
  other_age:[0,0,0,0,0,0,0],
  other_age_donut: [],
  other_gms_type_donut: [0,0],
  other_gms_type: [0,0]
  },
consultation:{
  current_year:[],
  previous_year: [],
  years_range: []
},
  abcomparison: {
    otherResistanceTotal:0,
    otherpractice_green: 0,
    otherpractice_red: 0,
    othertypes_prescribed: [],
    othertypes_resistance: [],
    othertypes_resistance_red: [],
    othertypes_red: [],

    othertypes_green: [],

    othertypes_resistance_green: [],
  },

  age: {
    other_age: [0, 0, 0, 0, 0, 0, 0],
    othergreen: [0, 0, 0, 0, 0, 0, 0],
    otherred: [0, 0, 0, 0, 0, 0, 0],
    categories: ["<1", "1-6", "7-17", "18-29", "30-49", "50-69", ">=70"],
  },

  hospitalarea: {
    green: [0, 0, 0, 0, 0, 0],
    red: [0, 0, 0, 0, 0, 0],
    categories: ["A", "B", "C", "D", "E", "F"],
  },

  patientnumber: {
    green: [0, 0, 0],
    red: [0, 0, 0],
    categories: [
      "Same number of patients",
      "Same number of GMS patients",
      "Same number of private patients",
    ],
  },

  gpnumber: {
    green: [9321, 10133, 5445, 8176],
    red: [3053, 1033, 5000, 7500],
    categories: ["1", "2-3", "4-5", ">5"],
  },

  locationarea: {
    green: [17633, 29899],
    red: [15200, 32100],
    categories: ["Rural", "Urban"],
  },

  time: {
    othergreen_weekday: [0, 0, 0, 0, 0],
    otherred_weekday: [0, 0, 0, 0, 0],
    othergreen_duration: [0, 0, 0, 0, 0],
    otherred_duration: [0, 0, 0,0, 0],
    green_2021: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    red_2021: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    green_2020: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    red_2020: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    previousYear: [],
    greenRed: [],
  },

otherIcpc_consultation:{
  icpccode:[],
  icpcdescription: [],
  icpc_count: []
}
};

// count model
export const antibioticscomparisons = {
  state: initial_state,

  reducers: {

    setDataLoaded(state, payload) {
      return {
        ...state,
        isDataLoaded: payload,
        loading1: payload,
        loading2: payload,
        loading3: payload,
        loading4: payload,
        loading5: payload,
        loading6: payload,
        loading7: payload,
        loadingP1: payload,
        loadingP2: payload,
        loadingP3: payload,
        loadingP4: payload,
        loadingP5: payload,
        loadingP6: payload,
        loadingP7: payload,
      }
    },

    setLoading(state, payload) {
      return {
        ...state,
        [payload.key]: payload.value
      }
    },

    updateCompare1(state, payload) {
      return {
        ...state,
        generalABcomparison: {
          ...state.generalABcomparison,
          othertotal: payload.ab_prescribed ? payload.ab_prescribed : 0,
          otherperc_12_month: payload.percentage_ab ? payload.percentage_ab : 0,
        },
      };
    },

    updateCompare2(state, payload) {
      const { count } = payload.abResistent || [];
      // Extract antibiotic names and their corresponding counts
      const data = count
        ? Object.entries(count).map(([name, count]) => ({ name, count }))
        : [];
      // Sort the data based on antibiotic name
      data.sort((a, b) => b.count - a.count);

      // Prepare data for rendering
      let resistanceData = [];
      let resistanceGreenData = [];
      let resistanceRedData = [];

      if (data.length >= 1) {
        resistanceData = data.slice(0, 8).map(({ name, count }, key) => {
          let fillColor, strokeColor;
          if (
            name === "Amoxicillin" ||
            name === "Trimethoprim" ||
            name === "Nitrofurantoin" ||
            name === "Fosfomycin"
          ) {
            fillColor = strokeColor = "#26734D";
            resistanceGreenData.push({
              x: name,
              y: count,
              fillColor,
              strokeColor,
            });
          } else if (
            name === "Co-Amoxyclav" ||
            name === "Cephalosporin" ||
            name === "Quinolones"
          ) {
            fillColor = strokeColor = "#cc3311";
            resistanceRedData.push({
              x: name,
              y: count,
              fillColor,
              strokeColor,
            });
          } else {
            fillColor = strokeColor = key % 2 === 0 ? "#26734D" : "#cc3311";
            key % 2 === 0
              ? resistanceGreenData.push({
                  x: name,
                  y: count,
                  fillColor,
                  strokeColor,
                })
              : resistanceRedData.push({
                  x: name,
                  y: count,
                  fillColor,
                  strokeColor,
                });
          }
          return {
            x: name,
            y: count,
            fillColor,
            strokeColor,
          };
        });
      } else {
        resistanceRedData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        resistanceGreenData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        resistanceData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
      }

      return {
        ...state,
        generalABcomparison: {
          ...state.generalABcomparison,
          otherperc_resistance_ab: payload.abResistent.resistance ? payload.abResistent.resistance : 0,
        },
        abcomparison: {
          ...state.abcomparison,
          otherResistanceTotal: payload.abResistent ? ( payload.abResistent.resistanceTotal ? payload.abResistent.resistanceTotal : '0') : '0',
          othertypes_resistance_red: resistanceRedData,
          othertypes_resistance_green: resistanceGreenData,
        },
      };
    },

    updateCompare3(state, payload) {
      const typesPrescribed = [];
      const abPrescriptions = payload?.abPrescriptions1 || [];
      const prescribedGreenData = [];
      const prescribedRedData = [];

      if (abPrescriptions.length >= 1) {
        for (let i = 0; i < abPrescriptions.length && i < 10; i++) {
          if (
            abPrescriptions[i].level_4 &&
            abPrescriptions[i].level_4 !== undefined
          ) {
            let fillColor, strokeColor;
            if (
              ["Penicillin", "Trimethoprim", "Nitrofurantoin"].includes(
                abPrescriptions[i].level_4
              )
            ) {
              fillColor = "#26734D";
              strokeColor = "#26734D";
              prescribedGreenData.push({
                x: abPrescriptions[i].level_4,
                y:
                  (parseInt(abPrescriptions[i].total) /
                    state.generalABcomparison.othertotal) *
                  100,
                fillColor: fillColor,
                strokeColor: strokeColor,
              });
            } else if (
              [
                "Penicillins with beta-lactam inhibitors",
                "Cephalosporin",
                "Quinolones",
                "Tetracyclines",
                "Macrolides",
              ].includes(abPrescriptions[i].level_4)
            ) {
              fillColor = "#cc3311";
              strokeColor = "#cc3311";
              prescribedRedData.push({
                x: abPrescriptions[i].level_4,
                y:
                  (parseInt(abPrescriptions[i].total) /
                    state.generalABcomparison.othertotal) *
                  100,
                fillColor: fillColor,
                strokeColor: strokeColor,
              });
            }

            typesPrescribed.push({
              x: abPrescriptions[i].level_4,
              y:
                (parseInt(abPrescriptions[i].total) /
                  state.generalABcomparison.othertotal) *
                100,
              fillColor: fillColor,
              strokeColor: strokeColor,
            });
          }
        }
      } else {
        prescribedRedData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        prescribedGreenData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        typesPrescribed.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
      }

      return {
        ...state,
        abcomparison: {
          ...state.abcomparison,
          othertypes_red: prescribedRedData,
          othertypes_green: prescribedGreenData,
        },
      };
    },

    updateCompare4(state, payload) {
      let practiceGreenTotal = 0;
      let practiceRedTotal = 0;
      let abPrescriptions = payload.abPrescriptions2 ? payload.abPrescriptions2 : null;

      if(abPrescriptions != null){
        abPrescriptions.forEach((prescription) => {
          if (prescription.ab_classification === "Green") {
            practiceGreenTotal = parseInt(prescription.total);
          }
          if (prescription.ab_classification === "Red") {
            practiceRedTotal = parseInt(prescription.total);
          }
        });
      }

      return {
        ...state,
        abcomparison: {
          ...state.abcomparison,
          otherpractice_green: practiceGreenTotal,
          otherpractice_red: practiceRedTotal,
        },
      };
    },

    updateCompare5(state, payload) {
      return {
        ...state,
        consultationscomparison: {
          ...state.consultationscomparison,
          otherall: payload.consultationsPrescriptionsAB1.all_consultations ? payload.consultationsPrescriptionsAB1.all_consultations : 0,
          otherab: payload.consultationsPrescriptionsAB1.ab_consultations ? payload.consultationsPrescriptionsAB1.ab_consultations : 0,
        },
        prescriptionscomparison: {
          ...state.prescriptionscomparison,
          otherall: payload.consultationsPrescriptionsAB1.all_prescriptions ? payload.consultationsPrescriptionsAB1.all_prescriptions : 0,
          otherab: payload.consultationsPrescriptionsAB1.ab_prescriptions ? payload.consultationsPrescriptionsAB1.ab_prescriptions : 0,
        },
      };
    },

    updateCompare6(state, payload) {
      const zero = [0, 0, 0, 0, 0, 0, 0];

      return {
        ...state,
        age: {
          ...state.age,
          othergreen: payload.abPrescriptionsByAgeGroup1
            ? payload.abPrescriptionsByAgeGroup1.Green
              ? payload.abPrescriptionsByAgeGroup1.Green
              : zero
            : zero,
          otherred: payload.abPrescriptionsByAgeGroup1
            ? payload.abPrescriptionsByAgeGroup1.Red
              ? payload.abPrescriptionsByAgeGroup1.Red
              : zero
            : zero,
        },
      };
    },

    updateCompare7(state, payload) {
      const zero = [0, 0, 0, 0, 0];
      const zero1 = [0, 0, 0, 0, 0];

      return {
        ...state,
        time: {
          ...state.time,
          othergreen_weekday: payload.abPrescriptionsByDayofWeek1.Green ? payload.abPrescriptionsByDayofWeek1.Green : zero,
          otherred_weekday: payload.abPrescriptionsByDayofWeek1.Red ? payload.abPrescriptionsByDayofWeek1.Red : zero,
          othergreen_duration: payload.abPrescriptionsByDuration1.Green ? payload.abPrescriptionsByDuration1.Green : zero1,
          otherred_duration: payload.abPrescriptionsByDuration1.Red ? payload.abPrescriptionsByDuration1.Red : zero1,
        },
      };
    },

    updateComparisonsAB(state, payload) {
      console.log("State before updateComparisonsAB:", state);

      let indexes_hospitalareas_filters = [];
      initial_state.hospitalarea.categories.forEach((cat, index) => {
        if (payload.all_state.filters.hospitalarea.includes(cat)) {
          indexes_hospitalareas_filters.push(index);
        }
      });
      if (indexes_hospitalareas_filters.length == 0) {
        indexes_hospitalareas_filters = [0, 1, 2, 3, 4, 5];
      }
      let indexes_gpnumbers_filters = [];
      initial_state.gpnumber.categories.forEach((cat, index) => {
        if (payload.all_state.filters.gpnumber.includes(cat)) {
          indexes_gpnumbers_filters.push(index);
        }
      });
      if (indexes_gpnumbers_filters.length == 0) {
        indexes_gpnumbers_filters = [0, 1, 2, 3];
      }
      let indexes_patientnumbers_filters = [];
      initial_state.patientnumber.categories.forEach((cat, index) => {
        if (payload.all_state.filters.patientnumber.includes(cat)) {
          indexes_patientnumbers_filters.push(index);
        }
      });
      if (indexes_patientnumbers_filters.length == 0) {
        indexes_patientnumbers_filters = [0, 1, 2];
      }
      let indexes_locationareas_filters = [];
      initial_state.locationarea.categories.forEach((cat, index) => {
        if (payload.all_state.filters.locationarea.includes(cat)) {
          indexes_locationareas_filters.push(index);
        }
      });
      if (indexes_locationareas_filters.length == 0) {
        indexes_locationareas_filters = [0, 1];
      }
      let indexes_ages_filters = [];
      initial_state.age.categories.forEach((cat, index) => {
        if (payload.all_state.filters.age.includes(cat)) {
          indexes_ages_filters.push(index);
        }
      });

      if (indexes_ages_filters.length == 0) {
        indexes_ages_filters = [0, 1, 2, 3, 4, 5, 6];
      }

      console.log("State after updateComparisonsAB:", state);

      return {
        ...state,
        prescriptions: {
          othertotal: Math.round(
            initial_state.prescriptions.othertotal * payload.percentage
          ),
          othermale: Math.round(
            initial_state.prescriptions.othermale * payload.percentage
          ),
          otherfemale: Math.round(
            initial_state.prescriptions.otherfemale * payload.percentage
          ),
          otheractive_patients: Math.round(
            initial_state.prescriptions.otheractive_patients *
              payload.percentage
          ),
          otherconsultations: Math.round(
            initial_state.prescriptions.otherconsultations * payload.percentage
          ),
          othertypes: initial_state.prescriptions.othertypes.map((m) =>
            Math.round(m * payload.percentage)
          ),
          other_week_days: initial_state.prescriptions.other_week_days.map(
            (m) => Math.round(m * payload.percentage)
          ),
          other_type_gms: Math.round(
            initial_state.prescriptions.other_type_gms * payload.percentage
          ),
          other_type_private: Math.round(
            initial_state.prescriptions.other_type_private * payload.percentage
          ),
        },
        generalABcomparison: {
          othertotal: Math.round(
            initial_state.generalABcomparison.othertotal * payload.percentage
          ),
          otherperc_12_month: Math.round(
            initial_state.generalABcomparison.otherperc_12_month *
              payload.percentage
          ),
          otherperc_resistance_ab: Math.round(
            initial_state.generalABcomparison.otherperc_resistance_ab *
              payload.percentage
          ),
        },
        consultationscomparison: {
          otherall: Math.round(
            initial_state.consultationscomparison.otherall * payload.percentage
          ),
          otherab: Math.round(
            initial_state.consultationscomparison.otherab * payload.percentage
          ),
        },
        prescriptionscomparison: {
          otherall: Math.round(
            initial_state.prescriptionscomparison.otherall * payload.percentage
          ),
          otherab: Math.round(
            initial_state.prescriptionscomparison.otherab * payload.percentage
          ),
        },
        abcomparison: {
          otherpractice_green: Math.round(
            initial_state.abcomparison.otherpractice_green * payload.percentage
          ),
          otherpractice_red: Math.round(
            initial_state.abcomparison.otherpractice_red * payload.percentage
          ),
          othertypes_prescribed:
            initial_state.abcomparison.othertypes_prescribed.map((m) => {
              return { ...m, y: Math.round(m.y * payload.percentage) };
            }),
          othertypes_green: initial_state.abcomparison.othertypes_green.map(
            (m) => {
              return { ...m, y: Math.round(m.y * payload.percentage) };
            }
          ),
          othertypes_red: initial_state.abcomparison.othertypes_red.map((m) => {
            return { ...m, y: Math.round(m.y * payload.percentage) };
          }),
          othertypes_resistance:
            initial_state.abcomparison.othertypes_resistance.map((m) => {
              return { ...m, y: Math.round(m.y * payload.percentage) };
            }),
          othertypes_resistance_red:
            initial_state.abcomparison.othertypes_resistance_red.map((m) => {
              return { ...m, y: Math.round(m.y * payload.percentage) };
            }),
          othertypes_resistance_green:
            initial_state.abcomparison.othertypes_resistance_green.map((m) => {
              return { ...m, y: Math.round(m.y * payload.percentage) };
            }),
        },
        age: {
          other_age: initial_state.age.other_age
            .filter((cat, idx) => indexes_ages_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage * 0.95)),
          othergreen: initial_state.age.othergreen
            .filter((cat, idx) => indexes_ages_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          otherred: initial_state.age.otherred
            .filter((cat, idx) => indexes_ages_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          categories:
            payload.all_state.filters.age.length > 0
              ? payload.all_state.filters.age
              : initial_state.age.categories,
        },

        hospitalarea: {
          green: initial_state.hospitalarea.green
            .filter((cat, idx) => indexes_hospitalareas_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          red: initial_state.hospitalarea.red
            .filter((cat, idx) => indexes_hospitalareas_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          categories:
            payload.all_state.filters.hospitalarea.length > 0
              ? payload.all_state.filters.hospitalarea
              : initial_state.hospitalarea.categories,
        },
        patientnumber: {
          green: initial_state.patientnumber.green
            .filter((cat, idx) => indexes_patientnumbers_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          red: initial_state.patientnumber.red
            .filter((cat, idx) => indexes_patientnumbers_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          categories:
            payload.all_state.filters.patientnumber.length > 0
              ? payload.all_state.filters.patientnumber
              : initial_state.patientnumber.categories,
        },
        gpnumber: {
          green: initial_state.gpnumber.green
            .filter((cat, idx) => indexes_gpnumbers_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          red: initial_state.gpnumber.red
            .filter((cat, idx) => indexes_gpnumbers_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          categories:
            payload.all_state.filters.gpnumber.length > 0
              ? payload.all_state.filters.gpnumber
              : initial_state.gpnumber.categories,
        },
        locationarea: {
          green: initial_state.locationarea.green
            .filter((cat, idx) => indexes_locationareas_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          red: initial_state.locationarea.red
            .filter((cat, idx) => indexes_locationareas_filters.includes(idx))
            .map((cat) => Math.round(cat * payload.percentage)),
          categories:
            payload.all_state.filters.locationarea.length > 0
              ? payload.all_state.filters.locationarea
              : initial_state.locationarea.categories,
        },
        time: {
          othergreen_weekday: initial_state.time.othergreen_weekday.map((m) =>
            Math.round(m * payload.percentage)
          ),
          otherred_weekday: initial_state.time.otherred_weekday.map((m) =>
            Math.round(m * payload.percentage)
          ),
          othergreen_duration: initial_state.time.othergreen_duration.map((m) =>
            Math.round(m * payload.percentage)
          ),
          otherred_duration: initial_state.time.otherred_duration.map((m) =>
            Math.round(m * payload.percentage)
          ),
          green_2021: initial_state.time.green_2021.map((m) =>
            Math.round(m * payload.percentage)
          ),
          red_2021: initial_state.time.red_2021.map((m) =>
            Math.round(m * payload.percentage)
          ),
          green_2020: initial_state.time.green_2020.map((m) =>
            Math.round(m * payload.percentage)
          ),
          red_2020: initial_state.time.red_2020.map((m) =>
            Math.round(m * payload.percentage)
          ),
        },
      };
    },


    updatePoCompare1(state, payload) {
      return {
        ...state,
        prescriptions: {
          ...state.prescriptions,
          othertotal: payload.prescriptionFilterd ? payload.prescriptionFilterd : 0,
          otheractive_patients: payload.activePatientFiltered ? payload.activePatientFiltered : 0,
          otherconsultations: payload.counsultationFiltered ? payload.counsultationFiltered : 0,
        },
      };
    },

    updatePoCompare2(state, payload) {
      const typesPrescribed = [];
      const prescription_by_type = payload?.PrescriptionsByTypeFiltered.categories || [];
      const prescription_by_type_count = payload?.PrescriptionsByTypeFiltered.count || [];

      if(prescription_by_type.length>=1){
        for (let i = 0; i < prescription_by_type.length; i++) 
        {
          if(prescription_by_type_count[i] && prescription_by_type_count[i] !== undefined)
          {
            typesPrescribed.push({
              x: prescription_by_type[i],
              y: prescription_by_type_count[i],
            });
          }
        }
      }else{
        typesPrescribed.push({
          x:'',
          y: 0,
      })
      }

      return {
          ...state,
          prescriptions: {
            ...state.prescriptions,
            othertypes: typesPrescribed,
            other_week_days: payload.PrescriptionsByDayofWeekFiltered ? payload.PrescriptionsByDayofWeekFiltered.filteredCount : [],
            
          },
        }
    },

    updatePoCompare3(state, payload) {
      const patient_count_gender = [];
      const gender_categories = [];
      const patient_num = payload?.patientCountByGenderFiltered.patient_num || [];

      for (const item of patient_num) {
        if (item.gender && item.count && item.gender !== undefined && item.gender !== null && item.gender !== "null") {
          patient_count_gender.push(parseInt(item.count));
          gender_categories.push(item.gender);
        }
    }

      return {
          ...state,
          patients:{
            ...state.patients,
            other_gender_patients: patient_count_gender, // payload[1]?.gender_patients,
            other_gender_categories: gender_categories,
          },
        }
    },

    updatePoCompare4(state, payload) {
      const patient_count_age = [];
      const patient_num = payload?.patientCountByAgeFiltered.age || [];
      let zero =0;
      let no18 =0;
      let no50 =0;
      let no70 =0;
      for (let i =0; i<patient_num.length ; i++) {
        if (patient_num[i] && i<3) {
          zero = zero + patient_num[i];
        } else if (patient_num[i] && i<5) {
          no18 = no18 + patient_num[i];
        } else if (patient_num[i] && i==5) {
          no50 = no50 + patient_num[i];
        } else {
          no70 = no70 + patient_num[i];
        }
    }
    patient_count_age.push(zero);
    patient_count_age.push(no18);
    patient_count_age.push(no50);
    patient_count_age.push(no70);

      return {
          ...state,
          patients:{
            ...state.patients,
            other_age:patient_num,
            other_age_donut:patient_count_age,
          },
        }
    },

    updatePoCompare5(state, payload) {

      const patient_gms_type = [];
      const patient_gms_type_donut = [];
      const patient_num = payload?.patientTypeCountFiltered.gms_type || [];

      for (const item of patient_num) {
        if (item.gmsstatus && item.gmsstatus=="1") {
          patient_gms_type[0]=item.count;
          patient_gms_type_donut[0]=parseInt(item.count);
          
        }
        if (item.gmsstatus && item.gmsstatus=="2") {
          patient_gms_type[1]=item.count;
          patient_gms_type_donut[1]=parseInt(item.count);
        }
      }

      return {
        ...state,
        patients:{
          ...state.patients,
          other_gms_type: patient_gms_type,
          other_gms_type_donut: patient_gms_type_donut
        },
      }
    },

    updatePoCompare6(state, payload) {
      return {
        ...state,
        consultation: {
          ...state.consultation,
          previous_year: payload.consultationsByYearFiltered.groupedYear,
          current_year: payload.consultationsByYearFiltered.groupedYear,
          years_range: payload.consultationsByYearFiltered.years
        }
      }
    },

    updatePoCompare7(state, payload) {
      const codedICPC = payload.coded_icpc_filtered;
      const icpcCodes = codedICPC?.map(item => ({
        code: item.icpccode,
        description: item.icpcdescription,
        count: item.icpc_count
      }));
      return {
        ...state,
        otherIcpc_consultation: {
          ...state.otherIcpc_consultation,
          icpccodes: icpcCodes?.map(code => code.code),
          icpc_descriptions: icpcCodes?.map(code => code.description),
          icpc_counts: icpcCodes?.map(code => code.count)
        }
      };
    },
    clearMap(state, payload) {
      try {

        apiCache1.clear();
        apiCache2.clear();
        apiCache3.clear();
        apiCache4.clear();
        apiCache5.clear();
        apiCache6.clear();
        apiCache7.clear();
        apiCacheP1.clear();
        apiCacheP2.clear();
        apiCacheP3.clear();
        apiCacheP4.clear();
        apiCacheP5.clear();
        apiCacheP6.clear();
        apiCacheP7.clear();

        return {
          ...state
        }; 
      } catch (error) {
        return error;
      }
    },
  },
  effects: (dispatch) => ({

    async compare_1(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache1.has(cacheKey)) {
          const cachedData = apiCache1.get(cacheKey);
          await this.setLoading({key: 'loading1', value: false});
          return this.updateCompare1(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading1', value: true});
        const compare_1 = await postData(
          config.url + "/compare/compare1",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            placeid: state.filters.locationarea,
            gender: state.filters.gender,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );
        
        apiCache1.set(cacheKey, compare_1);

        await this.setLoading({key: 'loading1', value: false});
        return await this.updateCompare1(compare_1);
      } catch (error) {
        return error;
      }
    },

    async compare_2(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache2.has(cacheKey)) {
          const cachedData = apiCache2.get(cacheKey);
          await this.setLoading({key: 'loading2', value: false});
          return this.updateCompare2(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading2', value: true});
        const compare_2 = await postData(
          config.url + "/compare/compare2",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache2.set(cacheKey, compare_2);
        await this.setLoading({key: 'loading2', value: false});
        return await this.updateCompare2(compare_2);
      } catch (error) {
        return error;
      }
    },

    async compare_3(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache3.has(cacheKey)) {
          const cachedData = apiCache3.get(cacheKey);
          await this.setLoading({key: 'loading3', value: false});
          return this.updateCompare3(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading3', value: true});
        const compare_3 = await postData(
          config.url + "/compare/compare3",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache3.set(cacheKey, compare_3);
        await this.setLoading({key: 'loading3', value: false});
        return await this.updateCompare3(compare_3);
      } catch (error) {
        return error;
      }
    },

    async compare_4(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache4.has(cacheKey)) {
          const cachedData = apiCache4.get(cacheKey);
          await this.setLoading({key: 'loading4', value: false});
          return this.updateCompare4(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading4', value: true});
        const compare_4 = await postData(
          config.url + "/compare/compare4",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: payload.payload ? payload.payload.end1 : state.filters.dateStart,
            end: payload.payload ? payload.payload.start1 : state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache4.set(cacheKey, compare_4);
        await this.setLoading({key: 'loading4', value: false});
        return await this.updateCompare4(compare_4);
      } catch (error) {
        return error;
      }
    },

    async compare_5(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache5.has(cacheKey)) {
          const cachedData = apiCache5.get(cacheKey);
          await this.setLoading({key: 'loading5', value: false});
          return this.updateCompare5(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading5', value: true});
        const compare_5 = await postData(
          config.url + "/compare/compare5",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache5.set(cacheKey, compare_5);
        await this.setLoading({key: 'loading5', value: false});
        return await this.updateCompare5(compare_5);
      } catch (error) {
        return error;
      }
    },

    async compare_7(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache7.has(cacheKey)) {
          const cachedData = apiCache7.get(cacheKey);
          await this.setLoading({key: 'loading7', value: false});
          return this.updateCompare7(cachedData); // Use cached
        }

        await this.setLoading({key: 'loading7', value: true});
        const compare_7 = await postData(
          config.url + "/compare/compare7",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache7.set(cacheKey, compare_7);
        await this.setLoading({key: 'loading7', value: false});
        return await this.updateCompare7(compare_7);
      } catch (error) {
        return error;
      }
    },

    async compare_6(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCache6.has(cacheKey)) {
          const cachedData = apiCache6.get(cacheKey);
          await this.setLoading({key: 'loading6', value: false});
          return this.updateCompare6(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loading6', value: true});
        const compare_6 = await postData(
          config.url + "/compare/compare6",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: ageIndex,
            age2: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCache6.set(cacheKey, compare_6);
        await this.setLoading({key: 'loading6', value: false});
        return await this.updateCompare6(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_1(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP1.has(cacheKey)) {
          const cachedData = apiCacheP1.get(cacheKey);
          await this.setLoading({key: 'loadingP1', value: false});
          return this.updatePoCompare1(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP1', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare1",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP1.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP1', value: false});
        return await this.updatePoCompare1(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_2(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP2.has(cacheKey)) {
          const cachedData = apiCacheP2.get(cacheKey);
          await this.setLoading({key: 'loadingP2', value: false});
          return this.updatePoCompare2(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP2', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare2",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP2.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP2', value: false});
        return await this.updatePoCompare2(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_3(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP3.has(cacheKey)) {
          const cachedData = apiCacheP3.get(cacheKey);
          await this.setLoading({key: 'loadingP3', value: false});
          return this.updatePoCompare3(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP3', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare3",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );
        
        apiCacheP3.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP3', value: false});
        return await this.updatePoCompare3(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_4(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP4.has(cacheKey)) {
          const cachedData = apiCacheP4.get(cacheKey);
          await this.setLoading({key: 'loadingP4', value: false});
          return this.updatePoCompare4(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP4', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare4",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: ageIndex,
            age2: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP4.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP4', value: false});
        return await this.updatePoCompare4(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_5(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP5.has(cacheKey)) {
          const cachedData = apiCacheP5.get(cacheKey);
          await this.setLoading({key: 'loadingP5', value: false});
          return this.updatePoCompare5(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP5', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare5",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP5.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP5', value: false});
        return await this.updatePoCompare5(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_6(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP6.has(cacheKey)) {
          const cachedData = apiCacheP6.get(cacheKey);
          await this.setLoading({key: 'loadingP6', value: false});
          return this.updatePoCompare6(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP6', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare6",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP6.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP6', value: false});
        return await this.updatePoCompare6(compare_6);
      } catch (error) {
        return error;
      }
    },

    async pocompare_7(payload, state) {
      try {

        const filters = state.filters;
        const cacheKey = generateCacheKey(filters);
        if (apiCacheP7.has(cacheKey)) {
          const cachedData = apiCacheP7.get(cacheKey);
          await this.setLoading({key: 'loadingP7', value: false});
          return this.updatePoCompare7(cachedData); // Use cached
        }

        let ageValues = state.antibiotics.age.categories;
        const ageRange = state.filters.age;
        let ageIndex = null;
        ageIndex =
          ageRange.length > 0
            ? ageRange.map((value) => {
                return ageValues.indexOf(value[0]);
              })
            : null;

        await this.setLoading({key: 'loadingP7', value: true});
        const compare_6 = await postData(
          config.url + "/compare/practicecompare7",
          {
            gps: state.filters.gps,
            healtharea: state.filters.healtharea,
            gms: state.filters.gms,
            age: state.filters.age,
            gender: state.filters.gender,
            placeid: state.filters.locationarea,
            start: state.filters.dateStart,
            end: state.filters.dateEnd,
          },
          state.user.access_token
        );

        apiCacheP7.set(cacheKey, compare_6);
        await this.setLoading({key: 'loadingP7', value: false});
        return await this.updatePoCompare7(compare_6);
      } catch (error) {
        return error;
      }
    },


    getComparisonsAB(payload, state) {
      console.log("state", state);
      let filters = [];
      let total_filters = 0;

      if (state.filters.hospitalarea.length > 0) {
        filters = filters + state.filters.hospitalarea.length;
        total_filters = total_filters + 6;
      }
      if (state.filters.age.length > 0) {
        filters = filters + state.filters.age.length;
        total_filters = total_filters + 7;
      }
      if (state.filters.gender.length > 0) {
        filters = filters + state.filters.gender.length;
        total_filters = total_filters + 3;
      }
      if (state.filters.gms.length > 0) {
        filters = filters + state.filters.gms.length;
        total_filters = total_filters + 2;
      }
      if (state.filters.gpnumber.length > 0) {
        filters = filters + state.filters.gpnumber.length;
        total_filters = total_filters + 4;
      }

      if (filters > 0 && total_filters > 0) {
        dispatch.antibioticscomparisons.updateComparisonsAB({
          percentage: filters / total_filters,
          all_state: state,
        });
      } else {
        dispatch.antibioticscomparisons.updateComparisonsAB({
          percentage: 1,
          all_state: state,
        });
      }
    },
  }),
};
